var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                disable: this.status == 2 ? false : true,
                color: "positive",
                label: _vm.$t("publish"),
                icon: "far fa-upload"
              },
              on: {
                click: function($event) {
                  _vm.confirm_publish = true
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                disable: this.status == 1 ? false : true,
                color: "info",
                label: _vm.$t("close_campaign"),
                icon: "far fa-check"
              },
              on: {
                click: function($event) {
                  _vm.confirm_close = true
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "campaigns" })
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.publishCampaign },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_publish = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("publish") },
                    on: {
                      click: function($event) {
                        return _vm.publishCampaign()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_publish,
            callback: function($$v) {
              _vm.confirm_publish = $$v
            },
            expression: "confirm_publish"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("publish_campaign")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(_vm.$t("are_your_sure_you_want_to_publish_the_campaign"))
            )
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.finishCampaign },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_close = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "negative",
                      label: _vm.$t("close_campaign")
                    },
                    on: {
                      click: function($event) {
                        return _vm.finishCampaign()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_close,
            callback: function($$v) {
              _vm.confirm_close = $$v
            },
            expression: "confirm_close"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("close_campaign")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(_vm.$t("are_your_sure_you_want_to_close_the_campaign"))
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }